<template>
  <a-card :bordered="false">
    <!-- 顶部筛选区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="报警编号">
              <a-input v-model.trim="queryParam.code" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="终端编号">
              <a-input v-model.trim="queryParam.terminalCode" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <template v-if="advanced">
            <a-col :md="8" :sm="24">
              <a-form-item label="终端类型">
                <a-select
                  showSearch
                  :filterOption="filterOption"
                  v-model="queryParam.terminalType"
                  default-value="0"
                  placeholder="请选择"
                >
                  <a-select-option value>全选</a-select-option>
                  <a-select-option
                    v-for="(item, index) in terminalTypeSelect"
                    :key="index"
                    :value="item.value"
                  >{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="报警等级">
                <a-select v-model="queryParam.level" placeholder="请选择">
                  <a-select-option value>全选</a-select-option>
                  <a-select-option
                    v-for="(item, index) in levelSelect"
                    :key="index"
                    :value="item.value"
                  >{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="报警状态">
                <a-select v-model="queryParam.status" placeholder="请选择">
                  <a-select-option value>全选</a-select-option>
                  <a-select-option
                    v-for="(item, index) in statusSelect"
                    :key="index"
                    :value="item.value"
                  >{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="报警类型">
                <a-select
                  showSearch
                  :filterOption="filterOption"
                  v-model="queryParam.type"
                  default-value="0"
                  placeholder="请选择"
                >
                  <a-select-option value>全选</a-select-option>
                  <a-select-option
                    v-for="(item, index) in typeSelect"
                    :key="index"
                    :value="item.value"
                  >{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item
                label="报警时间"
                :labelCol="{lg: {span: 7}, sm: {span: 7}}"
                :wrapperCol="{lg: {span: 10}, sm: {span: 17} }"
              >
                <a-range-picker
                  v-model="queryParam.time"
                  style="width: 100%"
                  :disabledDate="disabledDate"
                  :ranges="{ '今天': [moment().startOf('day'), moment().endOf('day')], '本月': [moment().startOf('month'), moment().endOf('day')] }"
                  showTime
                  format="YYYY-MM-DD HH:mm:ss"
                />
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="!advanced && 8 || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
            >
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 上部功能导航 -->
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd()">新建</a-button>
      <a-button
        type="dashed"
        v-if="config.hasAlert"
        @click="tableOption"
      >{{ optionAlertShow && '关闭' || '开启' }} alert</a-button>
    </div>

    <!-- 数据网格 -->
    <s-table
      ref="table"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns"
      :data="loadData"
      :alert="options.alert"
      :rowSelection="options.rowSelection"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}"
    >
      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a-dropdown>
          <a class="ant-dropdown-link">
            更多
            <a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item>
              <a @click="handleDetail(record)">详情</a>
            </a-menu-item>
            <a-menu-item>
              <a @click="handleDel(record)">关闭</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
    </s-table>

    <a-modal
      title="编辑"
      style="top: 20px;"
      :width="560"
      v-model="visible"
      @ok="handleOk"
      :confirmLoading="confirmLoading"
    >
      <a-form :form="form">
        <a-form-item label="物流单号" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input v-model="mdl.logisticsNo" placeholder="物流单号" />
        </a-form-item>

        <a-form-item label="工单编号" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input v-model="mdl.orderNo" placeholder="工单编号" />
        </a-form-item>

        <a-form-item label="终端类型" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select
            showSearch
            :filterOption="filterOption"
            v-model="mdl.terminalType"
            placeholder="请选择终端类型"
            v-decorator="['terminalType',
            { initialValue: mdl.terminalType, rules: [{ required: true, message: '请选择终端类型'}]}]"
          >
            <a-select-option
              v-for="(item, index) in terminalTypeSelect"
              :key="index"
              :value="item.value"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="终端编号" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input v-model="mdl.terminalCode" placeholder="终端编号" />
        </a-form-item>

        <a-form-item label="报警编号" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input
            v-model="mdl.code"
            placeholder="报警编号"
            v-decorator="['code',
            { initialValue: mdl.code, rules: [{ required: true, message: '请输入报警编号'}]}]"
          />
        </a-form-item>

        <a-form-item label="报警信息" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input
            v-model="mdl.msg"
            placeholder="报警信息"
            v-decorator="['msg',
            { initialValue: mdl.msg, rules: [{ required: true, message: '请输入报警信息'}]}]"
          />
        </a-form-item>

        <a-form-item label="报警等级" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select
            showSearch
            :filterOption="filterOption"
            v-model="mdl.level"
            placeholder="请选择报警等级"
            v-decorator="['level',
            { initialValue: mdl.level, rules: [{ required: true, message: '请选择报警等级'}]}]"
          >
            <a-select-option
              v-for="(item, index) in levelSelect"
              :key="index"
              :value="item.value"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="报警状态" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select
            showSearch
            :filterOption="filterOption"
            v-model="mdl.status"
            placeholder="请选择报警状态"
            v-decorator="['status',
            { initialValue: mdl.status, rules: [{ required: true, message: '请选择报警状态'}]}]"
          >
            <a-select-option
              v-for="(item, index) in statusSelect"
              :key="index"
              :value="item.value"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="原因说明" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input v-model="mdl.cause" placeholder="原因说明" />
        </a-form-item>

        <a-form-item label="处理结果" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input v-model="mdl.handResult" placeholder="处理结果" />
        </a-form-item>

        <a-form-item label="报警类型" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select
            showSearch
            :filterOption="filterOption"
            v-model="mdl.type"
            placeholder="请选择报警类型"
            v-decorator="['type',
            { initialValue: mdl.type, rules: [{ required: true, message: '请选择报警类型'}]}]"
          >
            <a-select-option
              v-for="(item, index) in typeSelect"
              :key="index"
              :value="item.value"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import { STable } from '@/components'
import { alarmPage, alarmUpdate, alarmSave, alarmDelete, codeList } from '@/api/sys'
import { formatDate } from '@/utils/date'
import moment from 'moment'
import storage from '@/utils/storage'
import queryMixin from '@/mixins/queryMixin'

export default {
  name: 'Privillege',
  mixins: [queryMixin],
  components: {
    STable
  },
  data() {
    return {
      pageSizeOptionsList:['10'],
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: null,
      // 表头
      columns: [
        {
          title: '#',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '报警编号',
          dataIndex: 'code'
        },
        {
          title: '报警等级',
          dataIndex: 'levelName'
        },
        {
          title: '报警状态',
          dataIndex: 'statusName'
        },
        {
          title: '报警类型',
          dataIndex: 'typeName'
        },
        {
          title: '终端编号',
          dataIndex: 'terminalCode'
        },
        {
          title: '终端类型',
          dataIndex: 'terminalTypeName'
        },
        {
          title: '发生时间',
          dataIndex: 'createTime',
          customRender: text => {
            let date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
        },
        {
          title: '操作',
          width: '130px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],

      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        // 日期处理
        if (this.queryParam.time !== undefined && this.queryParam.time.length > 1) {
          this.queryParam['startTime'] = formatDate(new Date(this.queryParam.time[0]), 'yyyy-MM-dd hh:mm:ss')
          this.queryParam['endTime'] = formatDate(new Date(this.queryParam.time[1]), 'yyyy-MM-dd hh:mm:ss')
        } else {
          this.queryParam['startTime'] = null
          this.queryParam['endTime'] = null
        }

        return alarmPage(Object.assign(parameter, this.queryParam)).then(res => {
          return res.data
        })
      },

      selectedRowKeys: [],
      selectedRows: [],

      // 终端类型
      terminalTypeSelect: null,
      // 所属菜单下拉
      typeSelect: null,
      // 所属菜单下拉
      levelSelect: null,
      // 所属菜单下拉
      statusSelect: null,

      // custom table alert & rowSelection
      options: {
        alert: {
          show: false,
          clear: () => {
            this.selectedRowKeys = []
          }
        },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: true
    }
  },
  created() {
    this.tableOption()
    this.loadSelect()

    // 初始化查询条件
    if (!this.queryParam){
      this.queryParam =  {time:[moment().startOf('day'), moment().endOf('day')]}
    }else{
      if (this.queryParam.time.length >0){
        this.queryParam.time[0] = moment(this.queryParam.time[0])
       this.queryParam.time[1] = moment(this.queryParam.time[1])
      }
    }
  },
  methods: {
    moment,
    disabledDate(current) {
      // Can not select days before today and today
      return current && current > moment().endOf('day')
    },
    loadSelect() {
      // 从后台拉去下拉列表数据
      new Promise(resolve => {
        const data = codeList({ typeCode: 'sys_terminal_type' }).then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        this.terminalTypeSelect = res
      })
      new Promise(resolve => {
        const data = codeList({ typeCode: 'sys_alarm_type' }).then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        this.typeSelect = res
      })
      new Promise(resolve => {
        const data = codeList({ typeCode: 'sys_alarm_level' }).then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        this.levelSelect = res
      })
      new Promise(resolve => {
        const data = codeList({ typeCode: 'sys_alarm_status' }).then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        this.statusSelect = res
      })
    },
    filterOption(input, option) {
      // 用于下拉列表可搜索
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    tableOption() {
      if (!this.optionAlertShow) {
        this.options = {
          alert: {
            show: false,
            clear: () => {
              this.selectedRowKeys = []
            }
          },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleEdit(record) {
      this.mdl = Object.assign({}, record)
      this.form = this.$form.createForm(this)
      this.visible = true
    },
    handleAdd() {
      this.mdl = {}
      this.form = this.$form.createForm(this)
      this.visible = true
    },
    handleOk() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          if (this.mdl.id !== undefined) {
            alarmUpdate(Object.assign({}, this.mdl))
              .then(res => {
                if (res.code === '0') {
                  this.$refs.table.refresh()
                  this.visible = false
                }
              })
              .catch(e => {
                console.log(e)
              })
              .finally(() => {
                this.confirmLoading = false
              })
          } else {
            alarmSave(Object.assign({}, this.mdl))
              .then(res => {
                if (res.code === '0') {
                  this.$refs.table.refresh()
                  this.visible = false
                }
              })
              .catch(e => {
                console.log(e)
              })
              .finally(() => {
                this.confirmLoading = false
              })
          }
        }
      })
    },
    handleDel(record) {
      var nthis = this
      this.$confirm({
        title: '提示',
        content: '确定要关闭吗?',
        onOk() {
          return alarmDelete({ ids: record.id })
            .then(res => {
              if (res.code === '0') {
                nthis.$refs.table.refresh()
              }
            })
            .catch(e => {
              console.log(e)
            })
            .finally(() => {})
        },
        onCancel() {}
      })
    },
    handleDetail(record) {
      storage.save('cache-AlarmDetail', JSON.stringify(record))
      this.$router.push({ name: 'AlarmDetail' })
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    }
  }
}
</script>
